import React, {useEffect, useRef, useState} from "react";
import {AnimatePresence, motion} from "framer-motion";
import MarketRepository from "../../../../Main/repository/MarketRepository";
import './assets/buyToolbar.scss';
import {sumBy} from "lodash";
import MarketCartLocalstorage from "../../../../Main/interface/MarketCartLocalstorage";
import ModalComponents from "../../../../../components/Modal/Modal";
import StateModalModel from "../../../../../components/Modal/Model/StateModalModel";
import Invoice from "../../../../Invoice/Invoice";
import InvoiceInterface from "../../../../Invoice/interface/invoiceInterface";
import marketSettingLocalStorage from "../../../../Main/interface/MarketSettingLocalStorage";
import AppSettingController from "../../../../Main/controller/AppSettingController";
import DiscountController from "../../../../Invoice/Controller/DiscountController";
import AppCartController from "../../../../Main/controller/AppCartController";
import {useTranslation} from "react-i18next";

export default function BuyToolbar() {
    const {t, i18n} = useTranslation();
    const setting = AppSettingController.getSetting() as marketSettingLocalStorage;
    const [isVisible, setIsVisible] = useState(false);
    const [card, setCard] = useState<MarketCartLocalstorage>(MarketRepository.getCartMarket());
    const [height, setHeight] = useState<number | "auto">(0);
    const contentRef = useRef<HTMLDivElement>(null);
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';
    const now = new Date().toLocaleDateString(lang);
    const nowClock = new Date().toLocaleTimeString(lang);
    const quantitySum = sumBy(card.items, 'quantity');
    const priceSum = AppCartController.priceSum();
    const priceSumWithExtraCosts = AppCartController.priceSum(true);
    const currency = setting.currency || t("currency.default");
    const [state, setState] = useState<InvoiceInterface>({
        time: {
            now,
            nowClock,
        },
        card,
        loading: false,
        discount: {
            show: false,
            isApplyDiscount: false
        },
        reRender: 0,
        price: {
            total: priceSumWithExtraCosts,
            regular: priceSum,
        },
        error: {
            status: false,
            message: ""
        },
        showPaymentMethod: false,
        paymentMode: '',
    })
    const [stateModal, setStateModal] = useState<StateModalModel>({
        closeLabel: "",
        show: false,
        submit(): void {
        },
        submitLabel: "",
        title: "",
        backdrop: 'static',
        modalClassName: "payment-modal mobile-invoice"
    })
    const price = state.price.regular.toLocaleString(lang);

    useEffect(() => {
        const tick = () => {
            const card = MarketRepository.getCartMarket();
            setCard(card);

            const hasItems = card.items?.length > 0;
            setIsVisible(hasItems);
            if (contentRef.current) {
                setHeight(hasItems ? contentRef.current.scrollHeight : 0);
            }
        };

        tick();
        const timer = setInterval(tick, 100);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const card = MarketRepository.getCartMarket();
        const sum = AppCartController.priceSum();
        const sumWithExtraCosts = AppCartController.priceSum(true);

        setState(prev => {
            const next = {
                ...prev,
                card,
                price: {total: sumWithExtraCosts, regular: sum},
            };
            if (prev.discount.isApplyDiscount) {
                new DiscountController(next, setState).discountCalculation();
            }
            return next;
        });

        setCard(card);
        if (!card.items?.length) {
            setStateModal(m => ({
                ...m,
                show: false,
            }));
            setState(m => ({
                ...m,
                discount: {
                    show: false,
                    isApplyDiscount: false
                },
            }));
        }
    }, [priceSum, state.reRender, state.discount.isApplyDiscount]);


    return (
        <>
            <AnimatePresence>
                {isVisible && (
                    <motion.div
                        className="buy-toolbar-container"
                        initial={{height: 0}}
                        animate={{height}}
                        exit={{height: 0}}
                        transition={{
                            duration: 0.2,
                            ease: "easeIn",
                        }}
                        style={{overflow: "hidden"}}
                        ref={contentRef}
                    >
                        <div>
                            <h3 className={`${state.discount.isApplyDiscount ? 'discount-price-toolbar' : ''}`}>
                                {setting.marketMode === 'no-payment' ? (
                                    <>{t("table.count")}{quantitySum}</>
                                ) : (
                                    <>{t("table.total")}{state.discount.isApplyDiscount ?
                                        <span>
                                            {state.price.total.toLocaleString(lang)}
                                            <s>{(state.price.regular + AppCartController.extraCostsPrice()).toLocaleString(lang)}</s>
                                        </span>
                                        : (priceSum + AppCartController.extraCostsPrice()).toLocaleString(lang)} {currency} -
                                        {t("table.number")}{quantitySum}
                                    </>
                                )}
                            </h3>
                            <button onClick={() => setStateModal({...stateModal, show: true})}>{t("setting.payment")}</button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
            <ModalComponents state={stateModal} setState={setStateModal}>
                <Invoice data={state} setData={setState}/>
            </ModalComponents>
        </>
    );
}
